// extracted by mini-css-extract-plugin
export default {"aside_link":"GlobalPagesLayout_aside_link__TBktg"};